import { PlatformAuthorizer } from 'fl-platform-authorizer';
import { SubscriptionAction } from '../../enums/subscription';
import { ProductsResponseModel } from '../../services/evergent/products/model/products-response-message.model';
import { ContainerVm, Facet, ResourceVm } from 'qp-ui-interface';
import { ContentType } from '../../enums/contentType';
import { vodDetails } from '../../services/evergent/entitlement/model/entitlement/vod-catalog-response.model';
import { TrackInfo } from 'fl-player-interface';

export interface CustomKeyValue {
  k: string;
  v: string;
}

export type LanguageKeys = 'TM' | 'TG' | 'EN';

export interface ResourceActionState {
  showPlayButton: boolean;
  showTrailerButton: boolean;
  showStartOverButton: boolean;
  showAddToListButton: boolean;
  showSubscriptionActionButton?: SubscriptionAction;
  subscriptionActionText?: string;
  showTvodButton?: boolean;
  showTvodHint?: boolean;
  playButtonText?: string;
  tvodButtonText?: string;
  tvodHintText?: string;
  catalogItem?: vodDetails;
}

export type ResStates = 'success' | 'failure' | 'pending';

export interface PaymentResponse {
  qrCode?: string;
  transactionID?: string;
  error?: any;
  state: ResStates;
}

export interface BookmarkMarker {
  contentId: string;
  platformAuthorizer: PlatformAuthorizer;
  seasonId?: string;
  episodeId?: string;
}

export interface IPlayer {
  key: number;
  isSelected: boolean;
  isUpsell?: boolean;
  value?: string;
  name: string;
  bandwidth?: number;
  track?: TrackInfo;
  isOriginal?: boolean;
  isDolbyAtmos?: boolean;
  isDolbyAudio?: boolean;
}

export interface IPlayerSkipInfo {
  start: number;
  end: number;
  isActive: boolean;
}

export interface IPaymentInput {
  resource?: ResourceVm;
  product?: ProductsResponseModel;
  isTvod?: boolean;
  redirectFrom?: string;
  popPages?: number | null;
  planName?: string;
}

export interface RouteOptions {
  resource: ResourceVm;
  navigationPath: string;
  state?: any;
  replaceHistory?: boolean;
}

export enum RouteStrategy {
  Default = 'default',
  PopAndReplace = 'popandreplace',
}

export interface IResourceList {
  resources: ResourceVm[];
  totalResources: number;
  facet?: Facet;
}

export interface IDetailResource {
  contentType?: ContentType;
  resource?: ResourceVm;
  activeResource?: ResourceVm;
}

export interface ITransaction {
  qrCode?: string;
  transactionID?: string;
  product?: ProductsResponseModel;
  resource?: ResourceVm;
  isTvod?: boolean;
}

export interface VerticalMenuEvent {
  action:
    | 'show'
    | 'hide'
    | 'open'
    | 'close'
    | 'active'
    | 'inactive'
    | 'disable'
    | 'no-action';

  data?: {
    tabId?: string;
    selectedIndex?: number;
    shouldFocus?: boolean;
    isMenuActive?: boolean;
    isHeroCarouselFocused?: boolean;
    reload?: boolean;
  };
}

export interface SeriesData {
  seasons: ResourceVm[];
  episodes: ContainerVm;
  activeSeasonId: string;
  activeEpisode: ResourceVm | null;
}
